export default __webpack_public_path__ + "static/media/08_odkorneni.27ea92c8.jpg";